import type { ListingState } from '@vs-shop/engine/capability/productListing/listingSelection';
import type { ListingBase } from '@vs-shop/engine/listing/codec';
import { listingSeo } from '@vs-shop/engine/listing/seo/ListingSeoPolicy';
import type { ListingVocabulary } from '@vs-shop/engine/listing/vocabulary/ListingVocabulary';
import { Predicate } from 'effect';

import { RCPROFI_LISTING_SYNTAX } from './listingConfig';

/** Keeps entity canonicals free of search parameters and preserves ordinary pagination. */
export const rcprofiListingCanonicalHref = (
  base: ListingBase,
  state: ListingState,
  vocabulary: ListingVocabulary
): string | undefined => {
  if (Predicate.isTagged(state.scope, 'Query')) return undefined;
  return listingSeo(
    { url: { pathname: base.url.pathname, query: [] }, preserved: [] },
    state,
    RCPROFI_LISTING_SYNTAX,
    vocabulary
  ).canonicalHref;
};
